// Identity-státusz badge (KÖZÖS) — a platform-identity `EntityStatus` értékkészletéhez (aktív/felfüggesztve/
// archivált). Bárhol újrahasználható, ahol egy IDENTITY státuszát mutatjuk (Munkatársak ÉS Kapcsolattartók).
// A jel (tónus + ikon) a KÖZÖS badge-katalógusból jön (`domain-badge.tsx`, `identityStatus`):
//   • active   → success (zöld) + pipa-kör · suspended → warning + pause · archived → muted + archív-doboz
//   • ismeretlen → muted + kör-pötty
// A lokalizált CÍMKÉT a hívó adja (pl. `t('employees.statusLabel.…')` / `t('contacts.statusLabel.…')`).
import { DomainBadge } from './domain-badge';

export interface IdentityStatusBadgeProps {
  status: string;
  label: string;
  className?: string;
}

export function IdentityStatusBadge({
  status,
  label,
  className,
}: IdentityStatusBadgeProps): JSX.Element {
  return <DomainBadge kind="identityStatus" value={status} label={label} className={className} />;
}
